import { render, staticRenderFns } from "./consent-form.vue?vue&type=template&id=63fd7271&scoped=true"
import script from "./consent-form.vue?vue&type=script&lang=js"
export * from "./consent-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd7271",
  null
  
)

export default component.exports